export const CONFIG_SET = 'config.CONFIG_SET';

export const setConfig = ({ locale, baseUrl }) => ({
    type: CONFIG_SET,
    payload: {
        locale,
        baseUrl,
    },
});
